<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-2">
        <mat-label>Booth Code <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <input type="number" [(ngModel)]="booth_code" class="main-border-class" />
      </div>
      <div class="col-3">
        <mat-label>Ordered Date <i class="material-icons" style="color: red;font-size: 14px;">star</i></mat-label>
        <input type="date" [(ngModel)]="ordered_date" class="main-border-class" />
      </div>
      <div class="col-2" style="margin-top: 3%;">
        <button mat-raised-button color="primary" (click)="serveCashReceipt()" class="button-class"
          style="font-size: 20px;" [disabled]="booth_code == null || ordered_date == null">Search</button>
        <mat-spinner [diameter]="40" *ngIf="data_loading"></mat-spinner>
      </div>
    </div>

    <div class="row" *ngIf="cash_receipt_data.length !== 0">
      <div class="col">
        <table class="table table-bordered">
          <thead style="text-align: center;">
            <tr>
              <th>S. No</th>
              <th>Cash Receipt Number</th>
              <th>Amount</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let cash_receipt of cash_receipt_data; let index=index">
              <td>{{ index + 1 }}</td>
              <td>{{ cash_receipt['receipt_number'] }}</td>
              <td>{{ cash_receipt['total_cost'] | currency: 'INR' }}</td>
              <td><button class="button-class" color="primary" mat-raised-button
                  (click)="downloadReceipt(cash_receipt)">Download</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>
